// extracted by mini-css-extract-plugin
export default {"userDetails":"DisplayUser_userDetails__r2Jpw","actionsButton":"DisplayUser_actionsButton__bugb1"};